// The staff error → toast mapping (Frontend §3.5, "Staff apps") for the codes a screen doesn't handle itself.
import { isApiError } from '@pa/api'
import type { ShowToast } from '@pa/ui'

export const SOMETHING_WENT_WRONG = 'Something went wrong. Try again.'

/** Shows the staff toast for an error a screen didn't map to a field or a state. */
export function toastApiError(toast: ShowToast, e: unknown): void {
  if (!isApiError(e)) {
    toast(SOMETHING_WENT_WRONG, 'error')
    return
  }
  const ref = e.requestId === undefined ? {} : { requestId: e.requestId }
  switch (e.code) {
    case 'forbidden':
      toast("You don't have permission to do that.", 'error', ref)
      return
    case 'rate_limited':
      toast(`Too many requests. Try again in ${String(e.retryAfterSec ?? 60)} s.`, 'error', ref)
      return
    case 'invalid_request':
      toast('Check the highlighted fields.', 'error', ref)
      return
    case 'not_found':
      toast('This clinic no longer exists.', 'error', ref)
      return
    default:
      toast(SOMETHING_WENT_WRONG, 'error', ref)
  }
}
